/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { get as getAxios, put as putAxios } from "../services/apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });

const put = (url, { accessToken, data, params, headers }) =>
  putAxios(url, { accessToken, data, endPoint, params, headers });

export default class getsessionRequest {
  static getLogingSession() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const memberId = localStorage.getItem("memberId");

    const request = get(
      `/api/login-history/member/${memberId}/source/BDS_PORTAL`,
      {
        accessToken: accessTokenFromLocal,
        headers: { "Content-Type": "application/json" },
      }
    );

    getsessionRequest.getLogingSession.cancel = request.cancel;
    return request;
  }
}
